import cx from 'classnames';
import { Contact } from 'src/types/dealInsights';
import { map, size } from 'lodash';
import styles from './styles.module.scss';
import moment from 'moment';
import Text from 'src/components/text';

interface DealContactsProps {
  contacts: Contact[];
}

const DefaultUserAvatar = '/images/default_user_profile_background.png';

const IndicatorDots = ({ value }: { value: number }) => {
  let count = 1;
  let color = 'red';

  if (value >= 70) {
    count = 3;
    color = 'green';
  } else if (value >= 35) {
    count = 2;
    color = 'orange';
  }

  return (
    <div className={styles.indicators}>
      {Array.from({ length: 3 }).map((_, i) => (
        <span
          key={i}
          className={cx(
            styles.dot,
            i < count && styles[color] // apply color only for active dots
          )}
        />
      ))}
    </div>
  );
};

export const DealContacts = ({ contacts }: DealContactsProps) => {
  if (!contacts || size(contacts) === 0) return <></>;

  return (
    <div className={styles.contactsContainer}>
      <h3 className={styles.title}>Deal Contacts ({size(contacts)})</h3>

      <div className={styles.contactsList}>
        {map(contacts, (contact) => (
          <div key={contact.externalId} className={styles.contactCard}>
            <div className={styles.avatar}>
              {contact.fullName ? <div className={styles.avatarPlaceholder}>
                {contact.fullName?.charAt(0) || '-'}
              </div> : <img src={DefaultUserAvatar} alt={'avatar'} className={styles.avatarImg} />}
            </div>

            <div className={styles.content}>
              <div className={styles.info}>
                <p className={styles.name}>{contact.fullName || '-'}</p>
                {(contact?.title || contact?.lastActivityDate) && (
                  <div className={styles.details}>
                    {contact.title && <div className={styles.title}>
                      <Text text={contact.title} tooltip={{ placement: "auto" }} />
                    </div>}
                    {contact.lastActivityDate && contact.title && <span className={styles.divider}></span>}
                    {contact.lastActivityDate && <p>Last activity: {moment(contact.lastActivityDate).format("DD MMM'YY")}</p>}
                  </div>
                )}
              </div>

              {/* <div className={styles.status}>
                <IndicatorDots value={contact.point} />
              </div> */}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DealContacts;
